import request from "@/utils/request";
import Qs from "qs";

/**
 * 资源总览
 * @param {*} params
 * @returns
 */
export function getResourceCount(params) {
  return request({
    url: "/resourceView/view",
    method: "post",
    data: Qs.stringify(params)
  });
}
/**
 * 地图分类打点
 * @param {*} params
 * @returns
 */
export function getResourceMap(params) {
  return request({
    url: "/resourceView/map",
    method: "post",
    data: Qs.stringify(params)
  });
}
/**
 * 获取资源点信息
 * @param {*} params
 * @returns
 */
export function getResourceDetail(params) {
  return request({
    url: "/resourceView/detail",
    method: "post",
    data: Qs.stringify(params)
  });
}
/**
 * 获取楼宇列表
 * @param {*} params
 * @returns
 */
export function buildingList(params) {
  return request({
    url: "/resourceEntAddress/building/buildingList",
    method: "post",
    data: Qs.stringify(params)
  });
}
/**
 * 获取楼宇列表
 * @param {*} params
 * @returns
 */
export function buildingListNoPage(params) {
  return request({
    url: "/resourceEntAddress/building/buildingListNoPage",
    method: "post",
    data: Qs.stringify(params)
  });
}
/**
 * 获取园区列表
 * @param {*} params
 * @returns
 */
export function parkList(params) {
  return request({
    url: "/resourceEntAddress/park/parkList",
    method: "post",
    data: Qs.stringify(params)
  });
}
/**
 * 获取园区列表
 * @param {*} params
 * @returns
 */
export function parkListNoPage(params) {
  return request({
    url: "/resourceEntAddress/park/parkListNoPage",
    method: "post",
    data: Qs.stringify(params)
  });
}
/**
 * 根据id获取信息
 * @param {*} params
 * @returns
 */
export function getBuildingDetailById(params) {
  return request({
    url: "/resourceEntAddress/building/getBuildingDetailById",
    method: "post",
    data: Qs.stringify(params)
  });
}
/**
 * 根据id获取信息
 * @param {*} params
 * @returns
 */
export function getLandDetailById(params) {
  return request({
    url: "/resourceEntAddress/land/getLandDetailById",
    method: "post",
    data: Qs.stringify(params)
  });
}
/**
 * 根据id获取信息
 * @param {*} params
 * @returns
 */
export function getParkDetailById(params) {
  return request({
    url: "/resourceEntAddress/park/getParkDetailById",
    method: "post",
    data: Qs.stringify(params)
  });
}
/**
 * 获取土地列表
 * @param {*} params
 * @returns
 */
export function landList(params) {
  return request({
    url: "/resourceEntAddress/land/landList",
    method: "post",
    data: Qs.stringify(params)
  });
}
/**
 * 获取土地列表
 * @param {*} params
 * @returns
 */
export function landListNoPage(params) {
  return request({
    url: "/resourceEntAddress/land/landListNoPage",
    method: "post",
    data: Qs.stringify(params)
  });
}
